export const API_URL: string = process.env.REACT_APP_API_URL as string;
export const APP_VERSION: string = process.env.REACT_APP_APP_VERSION as string;
